import * as ActionTypes from '../../app/ActionTypes';

import * as Services from '../../webAPI/MKSService';

const mapById = (results, idKey) => {
	const map = {};
	results.forEach(result => (map[result[idKey]] = result));
	return map;
};

const mapRightsByRoleId = roles => {
	const map = {};
	roles.forEach(role => {
		if (!map[role.role_id]) {
			map[role.role_id] = {};
		}
		role.lockings.forEach(lockingId => {
			map[role.role_id][lockingId] = true;
		});
	});
	return map;
};

export function getRolesRequest(projectId) {
	return function(dispatch) {
		dispatch({
			type: ActionTypes.GET_ROLES_REQUEST
		});
		return Services.getRoles(projectId).then(
			error => {
				dispatch({
					type: ActionTypes.GET_ROLES_FAIL,
					error
				});
			},
			result => {
				dispatch({
					type: ActionTypes.GET_ROLES_SUCCESS,
					roles: result,
					mappedRights: mapRightsByRoleId(result)
				});
			}
		);
	};
}

export function saveRoleRequest(projectId, roleId, fields) {
	return function(dispatch) {
		dispatch({
			type: ActionTypes.SAVE_ROLE_REQUEST
		});
		return Services.saveRole(
			projectId,
			fields.name,
			fields.number_of_keys,
			roleId
		).then(
			error => {
				dispatch({
					type: ActionTypes.SAVE_ROLE_FAIL,
					error
				});
			},
			result => {
				dispatch({
					type: ActionTypes.SAVE_ROLE_SUCCESS,
					// FIXME: server need to send just updated role
					roles: result,
					mappedRights: mapRightsByRoleId(result),
					roleId: result[result.length - 1].role_id
				});
			}
		);
	};
}

export function deleteRoleRequest(projectId, roleId) {
	return function(dispatch) {
		dispatch({
			type: ActionTypes.DELETE_ROLE_REQUEST,
			roleId
		});
		return Services.deleteRole(projectId, roleId).then(
			error => {
				dispatch({
					type: ActionTypes.DELETE_ROLE_FAIL,
					error
				});
			},
			result => {
				dispatch({
					type: ActionTypes.DELETE_ROLE_SUCCESS,
					result
				});
			}
		);
	};
}

export function changeRangeRolesRequest(projectId, roles) {
	return function(dispatch) {
		dispatch({
			type: 'CHANGE_RANGE_ROLES',
			roles
		});
		return Services.changeRangeRoles(projectId, roles).then(
			error => null,
			result => null
		);
	};
}

export function newRole() {
	return {
		type: ActionTypes.NEW_ROLE
	};
}

export function closeRoleForm() {
	return {
		type: ActionTypes.CLOSE_ROLE_FORM
	};
}

export function roleClick(roleId, activeRoleId) {
	return {
		type: ActionTypes.ROLE_CLICK,
		roleId: roleId === activeRoleId ? 0 : roleId
	};
}



// WEBPACK FOOTER //
// ./src/js/plan/roles/rolesActions.js